import { Injectable } from "@angular/core";
import { ClockService } from "../util/clock.service";

@Injectable()
export class LocalStorageTimerService {

  constructor(private clock: ClockService) {

  }

  storeToken(timerToken: string) {
    window.localStorage[timerToken] = this.clock.now(); 
  }

  hasTokenExpired(timerToken: string, limitInSeconds: number) {
    const dateStored = window.localStorage[timerToken] ? window.localStorage[timerToken] : null;
    if (!dateStored) { return true };

    const secondsLapsed = Math.abs(this.clock.now() - dateStored) / 1000;
    return secondsLapsed >= limitInSeconds;
  }

}